// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime, Duration } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';
import {
  NewReminderUserSettingsRecordData,
  ReminderUserSettingsRecordData,
  type ReminderUserSettingsRecordDataWireFormat,
} from '../ReminderUserSettingsRecordData/ReminderUserSettingsRecordData';

export class ReminderUserSettingSummary {
  readonly id: string;
  readonly recordType: Enums.ReminderUserSettingsRecordType;
  readonly recordData: ReminderUserSettingsRecordData;
  readonly recordBusinessDate: Enums.ReminderUserSettingsBusinessDate;
  readonly notifyBefore: Duration | null;
  readonly notifyAt: DateTime | null;
  readonly note: string | null;
  readonly createdAt: DateTime;
  readonly updatedAt: DateTime;
  readonly triggersAt: DateTime | null;
  readonly isArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.recordType =
      data.recordType === undefined
        ? Enums.ReminderUserSettingsRecordType.Project
        : data.recordType;
    this.recordData = NewReminderUserSettingsRecordData(data.recordData);
    this.recordBusinessDate =
      data.recordBusinessDate === undefined
        ? Enums.ReminderUserSettingsBusinessDate.BidDate
        : data.recordBusinessDate;
    this.notifyBefore = DateHelpers.ParseServerNullableDuration(data.notifyBefore);
    this.notifyAt = DateHelpers.ParseServerNullableDateTime(data.notifyAt);
    this.note = data.note === undefined ? null : data.note;
    this.createdAt = DateHelpers.ParseServerDateTime(data.createdAt);
    this.updatedAt = DateHelpers.ParseServerDateTime(data.updatedAt);
    this.triggersAt = DateHelpers.ParseServerNullableDateTime(data.triggersAt);
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
  }

  static zero(): ReminderUserSettingSummary {
    const zeroValues: ExcludeMethodsDeep<ReminderUserSettingSummary> = {
      id: NIL_UUID,
      recordType: Enums.ReminderUserSettingsRecordType.Project,
      recordData: ReminderUserSettingsRecordData.zero(),
      recordBusinessDate: Enums.ReminderUserSettingsBusinessDate.BidDate,
      notifyBefore: null,
      notifyAt: null,
      note: null,
      createdAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      updatedAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      triggersAt: null,
      isArchived: false,
    };
    return new ReminderUserSettingSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ReminderUserSettingSummaryWireFormat = {
  id: string;
  recordType: string;
  recordData: ReminderUserSettingsRecordDataWireFormat;
  recordBusinessDate: string;
  notifyBefore: string | null;
  notifyAt: string | null;
  note: string | null;
  createdAt: string;
  updatedAt: string;
  triggersAt: string | null;
  isArchived: boolean;
};

type NewReminderUserSettingSummaryProps = PartialDeep<
  ReminderUserSettingSummary,
  { recurseIntoArrays: true }
>;
export const NewReminderUserSettingSummary: (
  props: NewReminderUserSettingSummaryProps,
) => ReminderUserSettingSummary = (props) => new ReminderUserSettingSummary(props);

type NewReminderUserSettingSummaryFromWireFormatProps = PartialDeep<
  ReminderUserSettingSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewReminderUserSettingSummaryFromWireFormat: (
  props: NewReminderUserSettingSummaryFromWireFormatProps,
) => ReminderUserSettingSummary = (props) => new ReminderUserSettingSummary(props);
